module.exports = __webpack_public_path__ + "media/src/images/top_covers/xmas_image_03-31ed4744173074e62ae1d809114957f0.png";